import Cookies from "../Cookies";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import MainSection from "../MainSection/MainSection";
import Navbar from "../Navbar/Navbar";
import "./Layout.css";

function Layout() {
  return (
    <div> 
      <Navbar />
      <Header />
      <MainSection />
      <Cookies/>
      <Footer />
    </div>
  );
}

export default Layout;